import { useUser } from "@clerk/clerk-react";
import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import WorkshopForm from "../components/organisms/WorkshopForm";
import FormPageTemplate from "../components/templates/FormPageTemplate";
import { useTaskContext } from "../providers/TaskProvider";
import {
  insertTask,
  insertTaskAttachments,
  uploadMultipleFiles,
} from "../services/supabase";

export default function Workshop() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const formRef = useRef(null);

  const navigate = useNavigate();
  const { user } = useUser();
  const { refreshTasks } = useTaskContext();

  const handleSubmit = async (formData) => {
    if (!formData.title.trim()) {
      setError("Title is required");
      return;
    }

    setIsSubmitting(true);
    setError("");

    try {
      console.log("🔄 WORKSHOP: Starting task creation process");

      // Create task object
      const taskData = {
        title: formData.title,
        description: formData.description,
        status: "Ideation",
        assignee_id: formData.assigneeId || null,
        created_by: user?.id || null,
        created_at: new Date().toISOString(),
      };

      console.log("🔄 WORKSHOP: Task data prepared:", taskData);

      // Insert task into database
      console.log("🔄 WORKSHOP: Calling insertTask");
      const newTask = await insertTask(taskData);
      console.log("🔄 WORKSHOP: Insert task response:", newTask);

      if (newTask) {
        // Handle file uploads if there are files
        if (formData.selectedFiles.length > 0) {
          console.log(
            `🔄 WORKSHOP: Uploading ${formData.selectedFiles.length} files`
          );
          const uploadedFileUrls = await uploadMultipleFiles(
            formData.selectedFiles
          );

          if (uploadedFileUrls.length > 0) {
            // Map URLs to file objects with names
            const fileObjects = uploadedFileUrls.map((url, index) => ({
              url,
              name: formData.selectedFiles[index].name,
            }));

            // Insert attachments into task_attachments table
            await insertTaskAttachments(newTask.id, fileObjects);
            console.log(
              `✅ WORKSHOP: Uploaded ${fileObjects.length} attachments`
            );
          }
        }

        // Refresh the task list to ensure the new task appears
        refreshTasks();

        console.log("✅ WORKSHOP: Task created successfully:", newTask);
        setSuccess("Workshop idea pushed to Kanban board!");
        // Reset form after short delay
        setTimeout(() => {
          navigate("/");
        }, 1500);
      } else {
        console.error(
          "❌ WORKSHOP: Task creation failed - newTask is null/undefined"
        );
        setError(
          "Failed to create workshop idea. Server did not return task data."
        );
      }
    } catch (err) {
      console.error("❌ WORKSHOP: Error creating task:", err);
      setError("Failed to create workshop idea. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate("/");
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  return (
    <FormPageTemplate
      title="Workshop"
      subtitle="Brainstorm ideas and push them to the Kanban board"
      error={error}
      success={success}
      onSubmit={handleFormSubmit}
      onCancel={handleCancel}
      isSubmitting={isSubmitting}
      submitButtonText="Push to Kanban"
      cancelButtonText="Cancel"
    >
      <WorkshopForm
        ref={formRef}
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
    </FormPageTemplate>
  );
}
